/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Center, Container, Flex, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import BreadcrumbComponent from '../../../components/BreadcrumbComponent/BreadcrumbComponent';
import Company from '../../../components/Company';
import ExportExcelSummarizedReportIR from '../../../components/EarlyWarning/SummarizedReport/QuarterlyExcelSummarizedReportIR';
import NoData from '../../../components/NoData';
import PrintLayout from '../../../components/Print/PrintLayout';
import c from '../../../constant';
import useStore from '../../../store';
import { getDefaultFilterOptionValue, getFilterOptions } from '../../../utils/ews';
import { mappingKhmerNumber } from '../../../utils/market-development';
import Filter from '../../EarlyWarning/components/ews-quarter-summary-filter';
import { getFilterTitle, getYear } from '../../EarlyWarning/utils';
import InvestmentReportSpreadSheetTable from '../../EarlyWarning/components/QuarterlySummarizedIRReport/InvestmentReportSpreadSheetTable';

function QuarterlySummarizedFinancialReportDM({ industrial = true }) {
	const location = useLocation();
	const history = useHistory();
	const urlParams = new URLSearchParams(location.search);
	const reportId = urlParams.get('reportId') || null;
	const report = urlParams.get('report') || null;
	const year = urlParams.get('year') || null;
	const companyType = urlParams.get('companyType') || null;
	const companyId = urlParams.get('companyId') || null;
	const quarters = urlParams.get('quarters') ?? null;
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const [exportIR, setExportIR] = useState(null);

	const { currentUser: user } = useStore((state) => state?.currentUser);
	const [filterOptions, setFilterOptions] = useState([]);
	const [isPermitted, setPermitted] = useState(false);
	const [title, setTitle] = useState(null);
	useEffect(() => setFilterOptions(getFilterOptions({ industrial, user })), [user]);
	useEffect(() => setPermitted(filterOptions?.length > 0), [filterOptions]);
	useEffect(() => setTitle(companyType ? companyType : getDefaultFilterOptionValue({ filterOptions })), [companyType, filterOptions]);

	return (
		<PrintLayout>
			<Container maxW="container.xl" mt="16px" mb="16px">
				<BreadcrumbComponent
					list={[
						{
							name: 'Insurance Market Data',
							path: `/insurance-market-data`,
						},
						{
							name: 'Quarterly Investment Summarized Report',
							path: '#',
						},
					]}
				/>
				<Center mt="5">
					<Box
						w="100%"
						bg="white"
						borderRadius={c.borderRadius}
						border="1px solid #dbdbdb"
						boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
						pb="32px"
					>
						<Flex
							className="hidden-print"
							bg="#FAFAFA"
							p="16px"
							pt="8px"
							pb="8px"
							mb="0px"
							alignItems="center"
							justifyContent="space-between"
							borderBottom="1px solid #dbdbdb"
						>
							<Text fontSize="x-large" fontWeight="bold">
								{t('Quarterly Investment Summarized Report')}
							</Text>
							<Flex>
								{isPermitted && <ExportExcelSummarizedReportIR object={exportIR} mr={2} />}
								{isPermitted && (
									<Filter
										industrial={industrial}
										reportId={reportId}
										report={report}
										year={year}
										quarters={quarters}
										companyId={companyId}
										companyType={companyType}
										onCallback={(url) => history.push(`/insurance-market-data/industry-quarterly-summarized-ir-report${url}`)}
									/>
								)}
							</Flex>
						</Flex>
						{isPermitted ? (
							<>
								<Flex flexDirection="column" justifyContent="center" alignItems="center" pt={4} pl={4} pr={4} pb={1}>
									<Text fontSize="xl" fontWeight="700" color="blue.500" mb={1}>
										{t(getFilterTitle({ title, industrial }))}
									</Text>
									{companyId && (
										<Box mb={1}>
											<Company id={companyId} color="blue.500" />
										</Box>
									)}
									<Text fontSize="xl" fontWeight="700" color="blue.500">
										{lang === 'kh' ? mappingKhmerNumber(getYear(year)) : getYear(year)}
									</Text>
								</Flex>
								<Box pt={2} pl={4} pr={4}>
									<InvestmentReportSpreadSheetTable
										filterOptions={filterOptions}
										quarters={quarters}
										year={year}
										companyType={companyType}
										companyId={industrial ? null : companyId}
										onReadyForExport={(result) => setExportIR(result)}
									/>
								</Box>
							</>
						) : (
							<>
								<NoData />
							</>
						)}
					</Box>
				</Center>
			</Container>
		</PrintLayout>
	);
}

export default QuarterlySummarizedFinancialReportDM;
